<template>
  <section class="avaliacoes">
    <h1>Avaliações</h1>

    <div class="content">
      <VueSlickCarousel
        :arrows="true"
        :dots="true"
        v-bind="settingsCarousel"
      >
        <template v-for="(avaliacao, index) in testimonials">
          <Avaliacao 
            :key="index"
            :avaliacao="avaliacao"
          />
        </template>
      </VueSlickCarousel>
    </div>
  </section>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Avaliacao from "@/components/atomic/organisms/Avaliacao"

export default {
    name: "Testimonials",

    components: {
        VueSlickCarousel,
        Avaliacao
    },

    props: {
        testimonials: { type: Array, required: true }
    },

    data() {
        return {
            settingsCarousel: {
                "dots": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": false,
                "speed": 500,
                "slidesToShow": 3,
                "slidesToScroll": 1,
                "responsive": [
                  {
                    "breakpoint": 768,
                    "settings": {
                      "slidesToShow": 1,
                      "slidesToScroll": 1,
                      "infinite": true,
                      "dots": true
                    }
                  }
                ]
            },
        }
    }
}

</script>


<style lang="scss" scoped>
.avaliacoes {
    margin-bottom: 30px;
    
    h1 {
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        font-size: 30px;
        line-height: 34px;
        color: rgba(51, 50, 56, 0.84)
    }

    .content {
        background: #fff;
        padding: 0 30px;
        margin: 20px 0 0 0;
    }
}
</style>